export default Object.freeze({
    NOOP : 'NOOP',
    UPDATE :'UPDATE',
    CREATION : 'CREATION',
    DESTRUCTION: 'DESTRUCTION'
})
